import React from "react"
import styled from "styled-components"

import PlusCircleOutlined from "components/Icons/PlusCircleOutlined"

import { QuotaLimit } from "../../../interfaces/teamQuota"
import { t } from "../../../lib/i18n"

type InviteButtonProps = {
  invitableUsers: QuotaLimit
  onClick: () => void
}

const invitableUsersLabel = (invitableUsers: QuotaLimit): string => {
  switch (invitableUsers.kind) {
    case "unlimited":
      return t("invitable_user_count_unlimited")
    case "unmeasured":
      return t("invitable_user_count_unmeasured")
    default:
      return t("invitable_user_count", invitableUsers.value.toString())
  }
}

export function InviteButton(props: InviteButtonProps): JSX.Element {
  return (
    <div style={styles.form} onClick={props.onClick}>
      <PlusCircleOutlined style={styles.icon} />
      <Btn>
        {t("add_member")}({invitableUsersLabel(props.invitableUsers)})
      </Btn>
    </div>
  )
}

const Btn = styled.button`
  border-radius: 0;
  margin-left: 12px;
  border: none;
  padding: 0;
  width: 100%;
  background: transparent;
  font-size: 14px;
  color: ${(props) => props.theme.text.body1};
  text-align: left;
`

const styles: { [key: string]: React.CSSProperties } = {
  form: {
    display: "flex",
    padding: "12px 16px",
    justifyContent: "space-between",
    cursor: "pointer",
  },
  icon: {
    fontSize: 32,
  },
}
